'use strict';

import docinfo from './docinfo';
import menu from './menu';

const cover = {
  element: document.getElementById('cover'),
  setSize() {
    this.element.style.width = docinfo.viewportWidth() + 'px';
    this.element.style.height = docinfo.viewportHeight() - menu.getShape().height + 'px';
    this.element.style.marginTop = menu.getShape().height + 'px';
  },
  init() {
    this.setSize();
  }
};

export default cover;
